'use client';

import Header from './Header';
import Footer from './Footer';

export default function PageLayout({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground font-montserrat">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
